import { create } from 'zustand';

interface ContinueButtonConfig {
	isDisabled: boolean;
	isVisible: boolean;
	textId: string;
	onClick: () => Promise<void>;
}

interface ContinueButtonStore extends ContinueButtonConfig {
	validationDisabled: boolean;
	busyCount: number;
	setConfig: (config: ContinueButtonConfig) => void;
	setValidationDisabled: (value: boolean) => void;
	incrementBusy: () => void;
	decrementBusy: () => void;
}

export const useContinueButtonStore = create<ContinueButtonStore>((set) => ({
	isDisabled: false,
	isVisible: false,
	textId: 'button.next',
	onClick: () => Promise.resolve(),
	validationDisabled: false,
	busyCount: 0,
	setConfig: (config) => set({ ...config, busyCount: 0 }),
	setValidationDisabled: (value) => set({ validationDisabled: value }),
	incrementBusy: () => set((s) => ({ busyCount: s.busyCount + 1 })),
	decrementBusy: () => set((s) => ({ busyCount: Math.max(0, s.busyCount - 1) })),
}));
